import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  GET_SURVEY,
  DELETE_SURVEY,
  UPDATE_SURVEY,
  ADD_NEW_SURVEY,
} from "./actionType";

import {
  getSurveySuccess,
  getSurveyFail,
  deleteSurveySuccess,
  deleteSurveyFail,
  updateSurveySuccess,
  updateSurveyFail,
  addSurveySuccess,
  addSurveyFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getSurveyApi,
  updateSurveyApi,
  deleteSurveyApi,
  addNewSurveyApi,
} from "../../helpers/backend_helper";

function* getSurvey({ payload: survey }) {
  try {
    const response = yield call(getSurveyApi, survey);
    yield put(getSurveySuccess(GET_SURVEY, response.data));
  } catch (error) {
    yield put(getSurveyFail(GET_SURVEY, error));
  }
}

function* onUpdateSurvey({ payload: survey }) {
  try {
    const response = yield call(updateSurveyApi, survey);
    yield put(updateSurveySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateSurveyFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSurvey({ payload: survey }) {
  try {
    const response = yield call(deleteSurveyApi, survey);
    yield put(deleteSurveySuccess({ survey, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSurveyFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSurvey({ payload: survey }) {
  try {
    const response = yield call(addNewSurveyApi, survey);
    yield put(addSurveySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSurveyFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetSurvey() {
  yield takeEvery(GET_SURVEY, getSurvey);
}

export function* watchUpdateSurvey() {
  yield takeEvery(UPDATE_SURVEY, onUpdateSurvey);
}

export function* watchDeleteSurvey() {
  yield takeEvery(DELETE_SURVEY, onDeleteSurvey);
}

export function* watchAddNewSurvey() {
  yield takeEvery(ADD_NEW_SURVEY, onAddNewSurvey);
}

function* surveySaga() {
  yield all([
    fork(watchGetSurvey),
    fork(watchDeleteSurvey),
    fork(watchUpdateSurvey),
    fork(watchAddNewSurvey),
  ]);
}

export default surveySaga;
